import { Component } from '@angular/core';
import { ProtocolEntryDto } from '@interfaces/interfaces';

const HOUR = 3600_000;
const DAY = HOUR * 24;

@Component({
	selector: 'app-timeline-showcase',
	templateUrl: './timeline-showcase.component.html',
	styleUrls: ['./timeline-showcase.component.scss'],
})
export class TimelineShowcaseComponent {
	public readonly entries: ProtocolEntryDto[] = [
		{
			type: 'participant-delete',
			id: 'id_1',
			username: 'Paula',
			timestamp: Date.now() - 24*DAY,
			identifier: {
				pid: 'Taro'
			}
		},
		{
			type: 'participant-create',
			id: 'id_1',
			username: 'Johan',
			timestamp: Date.now() - 20*DAY,
			identifier: {
				pid: 'Taro'
			}
		},
		
		{
			type: 'participant-update',
			id: 'id_1',
			username: 'Paula',
			timestamp: Date.now() - 20*DAY + 4 * HOUR,
			identifier: {
				pid: 'Taro'
			}
		},
		{
			type: 'workflow-item-inprogress',
			id: 'id_1',
			username: 'Paul Panzer',
			timestamp: Date.now() - 9 * DAY,
			identifier: {
				itemid: 'BFS',
				pid: 'Test 1'
			}
		},
		{
			type: 'workflow-item-inprogress-reset',
			id: 'id_1',
			username: 'Daniel Düsentrieb',
			timestamp: Date.now() - 9 * DAY + 2 * HOUR,
			identifier: {
				itemid: 'BFS',
				pid: 'Test 1'
			}
		},
		{
			type:'config-archive-upload',
			id:'id_1',
			username: 'Gabriel',
			timestamp: Date.now() - 4 * DAY
		},
		{
			type: 'workflow-item-inprogress',
			id: 'id_1',
			username: 'Gerald',
			timestamp: Date.now() - 4 * DAY + 4 * HOUR,
			identifier: {
				itemid: 'BFS',
				pid: 'Test 1'
			}
		},
		{
			type: 'workflow-item-completed',
			id: 'id_1',
			username: 'Peter',
			timestamp: Date.now() - 4 * DAY + 4.5 * HOUR,
			identifier: {
				itemid: 'BFS',
				pid: 'Test 1'
			}
		},
		{
			type: 'workflow-item-completed-reset',
			id: 'id_1',
			username: 'Shoun das Schaf',
			timestamp: Date.now() - DAY,
			identifier: {
				itemid: 'BFS',
				pid: 'Test 1'
			}
		},
	];
}
